import React from 'react'

interface Props {
    value: number
    class: string
    showPlusSign: boolean
    showNoValueAsHyphen?: boolean
}

export const formatMilliseconds = (value: number, showNoValueAsHyphen: boolean = true, significantDigits?: number) => {
    const factors = [1000, 60, 60, 24]
    const sizes = ['ms', 's', 'm', 'h', 'days']
    const noValue = showNoValueAsHyphen ? '- ms' : '0 ms'
    let type = 0
    let decimals = 0

    if (!value) {
        return noValue
    }

    while (factors[type] && Math.abs(value) > factors[type]) {
        value /= factors[type]
        type++
    }

    if (sizes[type] === 'ms' || sizes[type] === 's') {
        if (value === 0) {
            return `0 ${sizes[type]}`
        }

        if (significantDigits) {
            const timeValue = new Intl.NumberFormat('en-US', {
                notation: 'standard',
                maximumSignificantDigits: significantDigits,
                maximumFractionDigits: 2,
            }).format(value)

            return `${timeValue} ${sizes[type]}`
        }

        // We could use Math.log to determine this, but I guess this is more
        // readable…
        if (value < 10) {
            decimals = 2
        } else if (value < 100) {
            decimals = 1
        }

        return `${value.toFixed(decimals)} ${sizes[type]}`
    } else if (sizes[type] === 'm' || sizes[type] === 'h') {
        const plainValue = Math.floor(value)
        const remaining = Math.round((value - plainValue) * 60)

        return `${plainValue} ${sizes[type]} ${remaining} ${sizes[type - 1]}`
    } else if (sizes[type] === 'days') {
        const plainDays = Math.floor(value)
        const remainingHours = Math.round((value - plainDays) * 24)

        return `${plainDays} days ${remainingHours} h`
    }
}

class Milliseconds extends React.Component<Props> {
    public static defaultProps = {
        value: 0,
        showPlusSign: false,
        class: 'response-time',
        showNoValueAsHyphen: true,
    }

    public render() {
        const className = 'unit ' + this.props.class
        const { showPlusSign, showNoValueAsHyphen } = this.props

        if (!this.props.value) {
            const nullValue = showNoValueAsHyphen ? '- ms' : '0 ms'

            return <span className={className}>{nullValue}</span>
        }

        const value = this.props.value / 1000

        const showSign = value >= 0 && showPlusSign ? '+' : ''
        return (
            <span className={className}>
                {showSign}
                {formatMilliseconds(value)}
            </span>
        )
    }
}

export default Milliseconds
